import { FLASH_TYPES as TYPES } from '@/consts';

import actions from './actions';
import mutations from './mutations';

const state = {
  message: '',
  acts: [],
  hovering: false,
  isActive: false,
  type: TYPES.INFO
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
